import { createCustomEvent } from "../../../../javascript/shared/helpers"

export default class extends Controller {

  connect() {
    this.emitSuccessEvent = this.emitSuccessEvent.bind(this)
    App.Helpers.ajaxRequest({ url: this.url, successHandler: this.emitSuccessEvent })
  }

  emitSuccessEvent(response) {
    document.dispatchEvent(createCustomEvent("digest-view:fetch-success", this.element, { response }))
  }

  get url() {
    return this.data.get("content-url")
  }
}



// WEBPACK FOOTER //
// ./app/components/my_via/assets/javascript/my-via-loading-day-controller.js